import React, { Component } from "react";
import {Card, Table, Spin} from "antd";
import ModalEdit from './ModalEdit';
import ModalDelete from './ModalDelete';

import { connect } from "react-redux";

import {
  fetchOrders,
} from "appRedux/actions/Orders";

function confirm(e) {
}

function cancel(e) {
}

function status(status){
  if(status==0){
    return "Pendiente"
  }else if(status==1){
    return "En curso"
  }else if(status==2){
    return "Completado"
  }else{
    return "Cancelado"
  }
}

class Simple extends Component {

  componentDidMount () {
    this.props.fetchOrders();
  }

  render () {

    const columns = [
      
      {
        title: 'Id ',
        dataIndex: 'id',
        key: 'id',
        }, {
        title: 'Nombre',
        dataIndex: 'name',
        key: 'name',
      }, {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
        }, {
        title: 'Télefono',
        dataIndex: 'phone',
        key: 'phone',
      },{
        title: 'Fecha del pedido',
        dataIndex: 'date',
        key: 'date',
        }, {
        title: 'Estado',
        dataIndex: 'status',
        key: 'status',
      },{
        title: 'Total',
        dataIndex: 'total',
        key: 'total',
      }, {
        title: 'Acción',
        key: 'action',
      
      
        render: (text, record) => (
          <span>
            <ModalEdit recording = {record} />
            <ModalDelete recording = {record} />
          </span>
        ),
      }
    ];
    const { orders } = this.props;
    //console.log(orders);

    let orderDecode = [];
    orderDecode = orders.map( (orders)=> {
      return ({
        id: orders.idorder,
        name: orders.full_name,
        email: orders.email,
        phone: orders.phone,
        total: orders.total,
        status: status(orders.delivery_status),
        date: orders.order_date,
      })
    });

    if (orderDecode == 0) {
        return  <Spin className="gx-loader-container" />;
    }

    return (
      <Card title="Pedidos">
        <br/>
        <Table className="gx-table-responsive" columns={columns}  dataSource={orderDecode}/>
      </Card>
    );
  }
};

function mapStateToProps({orders}) {
  return {
    orders
  }
}

export default connect (mapStateToProps, { fetchOrders })(Simple);


// WEBPACK FOOTER //
// ./src/routes/main/Cupons/verified/Basic.js